import { ReactNode } from 'react';

import { NavBar, NavBarContainer, Wrapper } from '../Common/Layout';
import { useAuth } from '../../common/Auth/useAuth';

interface ClaimLayoutProps {
  children?: ReactNode;
}

export const ClaimLayout = ({ children }: ClaimLayoutProps) => {
  const { user, loading } = useAuth();

  return (
    <Wrapper>
      {loading && <NavBarContainer />}
      {!loading && <NavBar user={user} />}

      {children}
    </Wrapper>
  );
};

export default undefined;
